module.exports = __webpack_public_path__ + "static/media/card-2.1307126a.svg";